export default __webpack_public_path__ + "718952f736ee7052416d69533b581051.svg";